// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"588":"css/app-legacy","615":"css/pdf","626":"css/app-automaatje","671":"css/app-mobile","703":"css/default/utilities","877":"css/default/regiworkflow/app"}[chunkId] + ".css";
};